<template>
  <v-card
    class="d-flex flex-row"
    :to="to"
    flat
    height="100%"
    width="100%"
    color="transparent"
  >
    <div class="limited mx-2">
      <med-package-image
        :imageFile="medData.file"
        :maxWidth="120"
        :maxHeight="150"
        :defaultHeight="150"
      ></med-package-image>
    </div>

    <div class="fullWidth pa-2 d-flex flex-column">
      <med-icon-block :listing="medData" class="" :row="true"></med-icon-block>
      <div class="mt-2 d-flex flex-row flex-wrap align-center">
        <div :class="sizeForTextLength" class="mr-3 brandColor">
          {{ medData.brand_name }}
        </div>

        <div v-if="generic_name" class="caption captionColor">
          <i>({{ concToPercent(generic_name) | truncate(70) }})</i>
        </div>
      </div>

      <div class="mt-1 caption">
        <div v-if="subtitles && subtitles.length > 1">
          Variations
          <ul v-for="subtitle in subtitles" :key="subtitle" class="caption">
            <li>{{ concToPercent(subtitle) | truncate(25) }}</li>
          </ul>
        </div>
        <div v-else-if="subtitles">
          {{ concToPercent(subtitles[0]) | truncate(70) }}
        </div>
      </div>

      <div class="mt-2 brandColor" v-html="manufacturer"></div>

      <!-- small screens only -->
      <div v-if="!$vuetify.breakpoint.smAndUp" class="my-3">
        <div v-if="medData.price > 0">
          <span class="font-weight-bold">Price<sup>*</sup>: </span>
          ${{ medData.price }}
          <span v-if="medData.price_generic > 0">
            (${{ medData.price_generic }} generic)</span
          >
        </div>
        <div v-if="medData.pediatric_unit">
          <span class="font-weight-bold"> Pediatric: </span>
          <span v-if="medData.pediatric_unit == 'all'">Indicated</span>
          <span v-else-if="medData.pediatric_unit == 'none'"
            >Not indicated</span
          >
          <span v-else-if="medData.pediatric_unit == 'mo'">
            {{ medData.pediatric_age }} mo</span
          >
          <span v-else-if="medData.pediatric_unit == 'yr'">
            {{ medData.pediatric_age }} yr</span
          >
        </div>
      </div>

      <!-- <v-card-text> -->
      <!-- <div>{{ slugText(row.brand_name, row.id) }}</div> -->
      <!-- <div>{{ row.synonym }}</div> -->

      <input type="hidden" data-field="rcui" :value="medData.rxcui" />
      <input
        type="hidden"
        data-field="product_ndc"
        :value="medData.product_ndc"
      />
      <input type="hidden" data-field="is_brand" :value="medData.is_brand" />
    </div>
  </v-card>
</template>

<script>
import MedIconBlock from "./MedIconBlock";
import MedPackageImage from "./MedPackageImage";
import ConcToPercentMixin from "@/assets/js/meds/ConcToPercentMixin";

// import Name from "../dir/file";

export default {
  name: "MedResultCard",
  components: {
    MedPackageImage,
    MedIconBlock,
  },
  mixins: [ConcToPercentMixin],
  props: {
    medData: null,
    to: null,
  },
  data: function () {
    return {};
  },
  methods: {
    // areSame(one, two) {
    //   return one.toLowerCase() == two.toLowerCase();
    // },
  },
  computed: {
    sizeForTextLength: function () {
      let rtn = "text-h6";
      if (!this.medData.brand_name) return rtn;
      let txt = this.medData.brand_name;
      let len = txt.length;
      if (len > 25) rtn = "font-weight-bold";
      return rtn;
    },

    // we'll return an array. usually there's just one subtitle but for some (mostly drops with multiple concentrations) there can be 2-3 variations
    // a subtitle can be a synonym or, if one isn't provided, the drug's generic name
    subtitles: function () {
      if (!this.medData) return null;
      let brand = this.medData.brand_name;
      let synonym = this.medData.synonym ? this.medData.synonym : "";
      // let generic = this.medData.generic_name ? this.medData.generic_name : "";
      // let subtitle = null;
      let subtitles = null;
      if (this.medData.variations) {
        subtitles = this.medData.variations;
      } else if (synonym != "" && !synonym.includes(this.generic_name)) {
        subtitles = [synonym];
      }
      // console.log(subtitles);
      if (subtitles && subtitles.length == 1) {
        let areSame = brand.toLowerCase() == subtitles[0].toLowerCase();
        subtitles = areSame ? null : subtitles;
      }

      return subtitles;
    },
    // usually there's just one synonym, but in some cases there may be multiple

    manufacturer: function () {
      if (!this.medData?.manufacturer) return null;
      let manufacturer = this.medData.manufacturer;
      if (this.medData.genericOptions) {
        let count = this.medData.genericOptions.length;
        if (count > 1) manufacturer = "<i>Various manufacturers</i>";
      }
      return manufacturer;
    },
    generic_name: function () {
      // console.log(this.medData.brand_name);
      let gn = this.medData.generic_name;
      let bn = this.medData.brand_name.toLowerCase();
      if (!gn) return null;
      if (bn.includes(gn.toLowerCase())) return null;

      return gn;
    },
  },
};
</script>

<style scoped>
.limited {
  width: 120px;
  height: 150px;
  overflow: hidden;
  display: block;
  padding: 10px;
  margin: 0 auto;
  min-width: 100px;
}
.truncate {
  width: 250px;
  height: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.brandColor {
  color: #065899;
}
.captionColor {
  color: #18831c;
}
/* .noOverflow {
  overflow: hidden;
  text-overflow: ellipsis;
} */
</style>
